import styled from '@emotion/styled';
import { Typography, tokens } from '@sunrun/experience-ui-components';

const POWER_SCORE_ITEMS = [
  { label: 'Install', points: '3 points' },
  { label: 'Close', points: '2 points' },
  { label: 'Sale', points: '1 point' },
] as const;

const PowerScoreLegend = () => (
  <LegendRoot>
    {POWER_SCORE_ITEMS.map(({ label, points }) => (
      <LegendItem key={label}>
        <Typography
          variant="span"
          size={12}
          lineHeight={17}
          color={tokens.TINTS_HERO_BLUE_60}>
          {label}
        </Typography>
        <Typography
          variant="span"
          size={12}
          lineHeight={14}
          fontWeight="medium"
          color={tokens.TINTS_HERO_BLUE_50}
          style={{ letterSpacing: '0.24px' }}>
          {points}
        </Typography>
      </LegendItem>
    ))}
  </LegendRoot>
);

const LegendRoot = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  margin: 10px 6px;
`;

const LegendItem = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
`;

export { PowerScoreLegend };
